// extracted by mini-css-extract-plugin
module.exports = {"someKnapp":"someBoks-module--someKnapp--3QL6n","filter":"someBoks-module--filter--3zbh-"};